import React from 'react';

const StarIcon = () => (
    <svg className="w-4 h-4" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
    </svg>
);

const TestimonialCard = ({ name, text }) => {
    return (
        <article className="card card-hover p-6 md:p-8 flex flex-col h-full relative">
            <div className="absolute -top-3 -left-1 text-brand-200 select-none" aria-hidden="true">
                <svg className="w-12 h-12" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M9.13 8C7.4 8 6 9.4 6 11.13c0 1.43.96 2.62 2.27 3l-.01.01c-.84 1.59-2.68 2.93-2.68 2.93s.7.97 1.55.97c2.74 0 5-2.26 5-5V11c0-1.66-1.34-3-3-3zm9 0c-1.73 0-3.13 1.4-3.13 3.13 0 1.43.96 2.62 2.27 3l-.01.01c-.84 1.59-2.68 2.93-2.68 2.93s.7.97 1.55.97c2.74 0 5-2.26 5-5V11c0-1.66-1.34-3-3-3z" />
                </svg>
            </div>
            <div className="flex items-center gap-0.5 text-amber-400 mb-4 relative">
                <StarIcon /><StarIcon /><StarIcon /><StarIcon /><StarIcon />
            </div>
            <p className="text-ink-700 leading-relaxed flex-1 whitespace-pre-line">
                {text}
            </p>
            <div className="mt-5 pt-5 border-t border-ink-100 flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-brand-50 text-brand-700 flex items-center justify-center font-semibold text-sm">
                    {name.charAt(0)}
                </div>
                <div>
                    <div className="font-semibold text-ink-900 text-sm">{name}</div>
                    <div className="text-xs text-ink-500">Recenze na Google</div>
                </div>
            </div>
        </article>
    );
};

export default TestimonialCard;
